/*
 * Query used to fetch vendor data
 * Below are the list of services that it talks to:
 * AWSSCMVendorMasterService
 */
import { gql } from '@apollo/client';

import { processResponse } from './helper';
import { ProductLine, QualificationStatus } from './searchVendorEntityQuery';

export interface GetVendorQueryResult {
  getVendor: {
    vendorOutput: {
      vendorEntityDetails: {
        name: string;
        parentVendorEntityId: string;
        classId: string;
        productLines: ProductLine[];
      };
    };
  };
}

export const getVendorQuery = gql`
  query getVendor($versionedId: VendorInput_VersionedIdentifier!) {
    getVendor(versionedId: $versionedId) {
      vendorOutput {
        vendorEntityDetails {
          name
          parentVendorEntityId
          productLines {
            categoryName
            departmentName
            qualificationStatus
          }
        }
      }
    }
  }
`;

export const getVendorQueryRequest = (vendorId: string) => {
  return {
    versionedId: {
      id: {
        value: vendorId
      }
    }
  }
}

export const getVendorQualificationForProductLine = (
  productLines: ProductLine[], 
  categoryName: string, 
  departmentName: string) : QualificationStatus | undefined => {
  return productLines.find(productLine => 
    productLine.categoryName === categoryName && productLine.departmentName === departmentName)?.qualificationStatus
}

export default function getVendor(vendorId: string): Promise<GetVendorQueryResult> {
  return processResponse(
    {
      query: getVendorQuery,
      variables: {
        versionedId: {
          id: {
            value: vendorId
          }
        }
      }
    },
    'getVendor'
  );
}
